import { connectionArchive, connectionByID, connectionDetail, connectionList, connectionUpdateSuccessFee } from '@/services/ventures/connections.service'

export default {
	namespaced: true,
	state: {
		connectionList: { meta: { pagination: { total: 0 } } },
		connection: {},
		connectionDetail: null,
		connectionStatus: 'pending',
		connectionDetailStatus: 'init',
	},
	getters: {
		getConnectionList: s => s.connectionList,
		getConnection: s => s.connection,
		getConnectionStatus: s => s.connectionStatus,
		getConnectionDetail: s => s.connectionDetail,
		getConnectionDetailStatus: s => s.connectionDetailStatus,
	},
	mutations: {
		CONNECTION_LIST(state, value) { state.connectionList = value },
		SET_CONNECTION(state, value) { state.connection = value },
		CONNECTION_STATUS(state, value) { state.connectionStatus = value },
		SET_CONNECTION_DETAIL(state, value) { state.connectionDetail = value },
		CONNECTION_DETAIL_STATUS(state, value) { state.connectionDetailStatus = value },
	},
	actions: {
		async fetchConnectionList({ commit }, params) {
			window.scrollTo({ top: 0, behavior: 'smooth' })
			commit('CONNECTION_STATUS', 'pending')
			commit('CONNECTION_LIST', { meta: { pagination: { total: 0 } } })
			try {
				const { data } = await connectionList(params)
				commit('CONNECTION_STATUS', 'init')
				commit('CONNECTION_LIST', data)
				return data
			} catch (error) {
				commit('CONNECTION_STATUS', 'init')
				throw error
			}
		},
		async fetchConnectionByID({ commit }, params) {
			commit('CONNECTION_STATUS', 'pending')
			try {
				const { data } = await connectionByID(params)
				commit('CONNECTION_STATUS', 'init')
				commit('SET_CONNECTION', data.data)
				return data
			} catch (error) {
				commit('CONNECTION_STATUS', 'init')
				return error
			}
		},
		async fetchConnectionDetail({ commit }, id) {
			commit('CONNECTION_DETAIL_STATUS', 'pending')
			try {
				const { data } = await connectionDetail(id)
				commit('SET_CONNECTION_DETAIL', data.data)
				commit('CONNECTION_DETAIL_STATUS', 'init')
				return data.data
			} catch (error) {
				commit('CONNECTION_DETAIL_STATUS', 'init')
				throw error
			}
		},
		async archiveConnection({ commit }, id) {
			try {
				const { data } = await connectionArchive(id)
				return data
			} catch (error) {
				throw error
			}
		},
		async updateSuccessFee({ commit }, { id, ...params }) {
			try {
				const { data } = await connectionUpdateSuccessFee(id, params)
				return data
			} catch (error) {
				throw error
			}
		},
	},
}
